// extracted by mini-css-extract-plugin
export var addButton = "_4y-d";
export var bullets = "_4y-e";
export var compact = "_4y-2";
export var container = "_4y-j";
export var extendedWarrantyModal = "_4y-f";
export var learn = "_4y-l";
export var learnMore = "_4y-g";
export var offeringOption = "_4y-3";
export var offeringPrice = "_4y-8";
export var offeringSubtitle = "_4y-7";
export var offeringTitle = "_4y-6";
export var offeringsContainer = "_4y-0";
export var pdpTilesBackground = "_4y-n";
export var plan = "_4y-m";
export var regular = "_4y-1";
export var remove = "_4y-k";
export var seeDetailsIcon = "_4y-i";
export var seeDetailsLink = "_4y-h";
export var selectedOption = "_4y-4";
export var shieldIcon = "_4y-b";
export var shieldIconCompact = "_4y-c";
export var subtitle = "_4y-a";
export var title = "_4y-9";
export var unselectedOption = "_4y-5";